import {
    AttachmentInfo,
    EntityStatus,
	ItemTag,
	AppUserInfo,
    LookupListItem
} from "./entities";
import { AppEntity } from "./app-entity";
import {type, association, resource} from 'aurelia-orm';

@resource("childiteminfo")
export class ChildItemInfo extends AppEntity {
    id: number;
    name: string;
	description: string;
	risk: string;
	details: string;
	note: string;
	entityStatusId: number;
	folderName: string;
	isChecked: boolean;
	@association({ collection: 'itemTags' })
	itemTags: Array<ItemTag> = [];

	//@association('itemStatus')
	entityStatus: EntityStatus;

	//closeStatus: CloseStatus;

    parentId: number;
    //guid: string;

	ownedById: number;
	//ownedByName: string;

	assignedToId: number;

	assignedTo: AppUserInfo;

	//assignedToName: string;

	@type('date')
    startDate: Date;

	@type('date')
	closeDate: Date;

	@type('date')
    dueDate: Date;

    budget: number;
    cost: number;
    progress: number;
	itemStatusId: number;
	closeStatusId: number;

    //@association('statusType')
    //itemStatus: ItemStatus;

    isEditing:boolean = false;

    test() {
        console.log("hello from item");
    }

    @association('comment')
	comments: Array<Comment>;

	@association('history')
	history: Array<History>;

    @association('attachmentInfo')
    attachmentInfos: Array<AttachmentInfo>;

    importanceTypeId: number;

    //@association('importanceType')
    //importanceType: ImportanceType;

    priorityTypeId: number;

    //@association('priorityType')
	//priorityType: PriorityType;

	timeScaleType: LookupListItem;

	timeEstimate: number;

	timeScaleTypeId: Number;

	itemTypeId: number;

	

    //@association()
    //itemType: ItemType;

   

   
    

}